
import { mapMutations, mapGetters, mapActions } from 'vuex';
import SearchHeader from '@/components/header/Tertiary/SearchHeader.vue';
import Catalog from '@/components/header/Tertiary/Catalog.vue';
import viewport from '~/mixins/viewport';
import header from '~/mixins/header';

export default {
    mixins: [viewport, header],
    components: {
        SearchHeader,
        Catalog
    },
    data() {
        return {
            loadCatalog: false,
            loader: false,
            userTheme: 'light_theme',
            isCabinetWindowOpen: false
        };
    },
    watch: {
        headerShow(newValue) {
            if (newValue) {
                document.querySelector('html').classList.add('hidden');
            } else {
                document.querySelector('html').classList.remove('hidden');
            }
        },
        '$i18n.locale': '$fetch'
    },
    computed: {
        headerShow() {
            return this.$store.state.headerShow;
        },
        ...mapGetters({
            favoritesProductsLength: 'favorites/getProductsLength',
            compareProductsLength: 'compare/getCompareProductsLength',
            cartProductsLength: 'cart/getProductsLength',
            globalSettings: 'global/globalSettings',
            getStateCatalog: 'getStateCatalog',
            isAuth: 'auth/isAuth'
        })
    },
    methods: {
        ...mapMutations({
            setStateHeader: 'setStateHeader',
            setStateCatalog: 'setStateCatalog',
            setStateSearch: 'setStateSearch',
            setShowNavigationMobile: 'setShowNavigationMobile'
        }),
        ...mapActions('cart', ['openCart']),
        openMenu() {
            this.setStateCatalog(!this.getStateCatalog);
        },
        openSearch() {
            this.setStateSearch(true);
        },
        async userIconClickHandler() {
            if (this.isAuth) {
                this.isCabinetWindowOpen = !this.isCabinetWindowOpen;
            } else {
                await this.$store.dispatch('setShowAuth', true);
            }
        },
        setIsCabinetWindowOpen(flag) {
            this.isCabinetWindowOpen = flag;
        },
        toCabinetLink(link) {
            this.setIsCabinetWindowOpen(false);
            this.$router.push(this.localePath(link));
        },
        logout() {
            this.$store.dispatch('auth/logout');
        },
        triggerAuthBtn() {
            if (this.isAuth) this.logout();
            else this.$store.dispatch('setShowAuth', true);

            this.setIsCabinetWindowOpen(false);
        },
        ...mapMutations(['setMainMenu']),

        async fetchMenuList() {
            let menu = await this.$axios.$get('general/menu_tree');
            if (menu.length) {
                this.setMainMenu(menu);
            }
        },
        toggleMenu() {
            this.setShowNavigationMobile(!this.getShowNavigationMobile);
        }
    },
    async fetch() {
        await this.fetchMenuList();
    }
};
